module.exports = __webpack_public_path__ + "d731cafd2f081e6884d280cd58f2d2eb.png";